import { render, staticRenderFns } from "./EPosterPib.vue?vue&type=template&id=689e3ea2"
import script from "./EPosterPib.vue?vue&type=script&lang=js"
export * from "./EPosterPib.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports